<div class="table-content">
  <nz-table
    nzSize="small"
    nzTableLayout="fixed"
    [nzData]="rowsToDisplay"
    nzShowPagination
    nzShowSizeChanger
    [nzLoading]="isLoading"
    [nzFrontPagination]="true"
    [nzTotal]="totalCount!"
    [nzOuterBordered]="true"
    [nzPageSizeOptions]="supportedPageSizes"
    [nzNoResult]="noResultTemplate"
    [nzHideOnSinglePage]="false"
    [nzVirtualItemSize]="11"
    [nzScroll]="{ x: '100rem', y: '30rem' }"
    #borderedTable
    nzBordered
  >
    <thead>
      <tr>
        <th
          *ngFor="let cell of headers; index as i"
          nz-resizable
          [nzSortOrder]="cell.sortOrder"
          [nzSortFn]="cell.sortFn"
          [nzSortDirections]="cell.sortDirections"
          [nzFilterMultiple]="cell.filterMultiple"
          [nzFilters]="cell.listOfFilter"
          [nzFilterFn]="cell.filterFn"
          [nzWidth]="cell.width ?? '8rem'"
          [nzRight]="cell.right"
          [nzLeft]="cell.left"
          class="nfl-form-label"
          [nzCustomFilter]="i === 1"
          appResizableColumn
          [isDynamicTable]="true"
        >
          {{ cell.name }}
          <nz-filter-trigger
            *ngIf="i === 1"
            [(nzVisible)]="visible"
            [nzActive]="searchValue!.length > 0"
            [nzDropdownMenu]="menu"
          >
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of borderedTable.data">
        <td nzEllipsis [nz-tooltip]="data.queryId">{{ data.queryId }}</td>
        <td nzEllipsis [nz-tooltip]="data.name">{{ data.name }}</td>
        <td nzEllipsis [nz-tooltip]="data.description">{{ data.description }}</td>
        <td>{{ data.type | titlecase }}</td>
        <td nzEllipsis [nz-tooltip]="data.query">{{ data.query }}</td>
        <td>{{ data.lastModifiedBy }}</td>
        <td>{{ data.lastModifiedAt | dateTime }}</td>
        <td nzAlign="center">
          <nz-tag
            [nzColor]="getValidationStatusColor(data.validationStatus?.toUpperCase())"
            *ngIf="data?.validationStatus; else blankCellTpl"
          >
            {{ data.validationStatus | titlecase }}
          </nz-tag>
        </td>
        <td nzAlign="center">
          <nz-tag
            [nzColor]="getSyntheticStatusColor(data.syntheticResult?.toUpperCase())"
            *ngIf="data?.syntheticResult; else blankCellTpl"
          >
            {{ data.syntheticResult | titlecase }}
          </nz-tag>
        </td>
        <td nzAlign="center">
          <nz-tag
            [nzColor]="getApprovalStatusColor(data.approvalStatus?.toUpperCase())"
            *ngIf="data?.approvalStatus; else blankCellTpl"
          >
            {{ data.approvalStatus | titlecase }}
          </nz-tag>
        </td>
        <td nzEllipsis [nz-tooltip]="data.rejectReason" nzAlign="center">{{ data.rejectReason || '--' }}</td>
        <td nzAlign="center">
          <nz-tag
            [nzColor]="getExecutionStatusColor(data.executionStatus)"
            *ngIf="data?.executionStatus; else blankCellTpl"
          >
            {{ data.executionStatus | titlecase }}
          </nz-tag>
        </td>
        <td nzAlign="center">
          {{ getExecutionDuration(data?.executionDuration) }}
        </td>
        <td nzAlign="center">
          <button
            nz-button
            nzType="primary"
            nzShape="round"
            *ngIf="canViewResult(data); else blankCellTpl"
            [routerLink]="['/query/result', data.queryId]"
          >
            View
          </button>
          <ng-template #blankCellTpl>
            <span nz-typography>--</span>
          </ng-template>
        </td>
        <td nzAlign="center" nzRight>
          <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu">
            <span nz-icon nzType="more"></span>
          </button>
          <nz-dropdown-menu #actionMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="viewQueryRecord(data)">
                {{ isUserAnalystOrAdmin() && canApproveOrReject(data) ? 'Review & Approve' : 'View Details' }}
              </li>
              <li nz-menu-item [routerLink]="['/query/edit', data.queryId]" *ngIf="canEdit(data)">Edit</li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search name" [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>

<ng-template #noResultTemplate let-name>
  <div>
    <span nz-icon nzType="file-sync" nzTheme="outline"></span>
    <p>No records available</p>
  </div>
</ng-template>
